// react
import React, {
  Fragment,
  useEffect,
  useReducer,
  useState,
  useRef,
} from 'react';

// styles
import styles from './index.module.scss';
// components
import { NavHeader } from './../../../components/navHeader/index';
import { BtnSmall } from '../../../components/btns/btnSmall';
import { Seperator } from '../../../components/seperator';
import { Note } from '../../../components/note';
// reducer
import {
  componentStatesInitialState,
  componentStatesReducer,
} from './indexReducer';
// MUI
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import CircularProgress from '@mui/material/CircularProgress';
// router
import { useNavigate } from 'react-router-dom';
// redux
import { useSelector } from 'react-redux';
// services
import {
  getStudentsNumberRequest,
  getAppointedStudentsRequest,
  scheduleStudentsRequest,
  downloadStudentDataRequest,
} from '../../../services/adminService';
import { downloadAppointedSocialData } from '../../../services/userService';
// js-cookies
import Cookies from 'js-cookie';
// datepicker
import './react-datepicker.css';
import DatePicker from 'react-datepicker';

/***************************************************************************/
/* Name : Schedule React schedule */
/***************************************************************************/
const SchedulePage = React.memo(() => {
  const navigate = useNavigate();
  // reducer
  const [componentStates, dispatchComponentStates] = useReducer(
    componentStatesReducer,
    componentStatesInitialState
  );
  const datePlaceholder = 'dd/MM/yyyy';
  const [day, setDay] = useState(new Date());
  const [api_url, setApi_url] = useState(
    useSelector((state) => state.ui.api_url)
  );
  const [token, setToken] = useState(Cookies.get('token'));
  // states
  const [numberOfStudents, setNumberOfStudents] = useState(0);
  const [numberOfStudentsCompleted, setNumberOfStudentsCompleted] = useState(0);
  const [
    numberOfStudentsCompletedWaiting,
    setNumberOfStudentsCompletedWaiting,
  ] = useState(0);

  const [numberOfStudentsScheduledM, setNumberOfStudentsScheduledM] =
    useState(0);
  const [numberOfStudentsScheduledE, setNumberOfStudentsScheduledE] =
    useState(0);
  // states
  const [periodSelected, setPeriodSelected] = useState('9:00');
  const [periodPrintedSelected, setPeriodPrintedSelected] = useState('9:00');
  const periodData = [
    { value: '9:00', title: 'الفترة الصباحية' },
    { value: '12:00', title: 'الفترة المسائية' },
  ];
  // refs
  const noOfStudentsRef = useRef(null);
  const [printPath, setPrintPath] = useState('');

  /******************************************************************/
  /* useEffect */
  /******************************************************************/
  useEffect(() => {
    (async () => {
      const token = Cookies.get('token');
      if (!token) {
        navigate('/admin/login');
      }
      // get students number
      await getStudentsNumberHandler();
      // get appointed students
      await getAppointedStudentsHandler(day);
    })();
  }, []);
  /******************************************************************/
  /* getStudentsNumber */
  /******************************************************************/
  const getStudentsNumberHandler = async () => {
    // dispatch states
    dispatchComponentStates({ type: 'PENDING' });
    const responseData = await getStudentsNumberRequest();
    if (responseData.status === 'success') {
      // set states
      //setNumberOfStudents(responseData.data.studentsNumber);
      //setNumberOfStudentsCompleted(responseData.data.completedStudentsNumber);
      setNumberOfStudentsCompletedWaiting(responseData.data.studentsWaiting);
      // CLEAR
      dispatchComponentStates({ type: 'CLEAR' });
    } else {
      // dispatch states
      dispatchComponentStates({
        type: 'ERROR',
        errorMessage: responseData.message,
      });
    }
  };
  /******************************************************************/
  /* getAppointedStudents */
  /******************************************************************/
  const getAppointedStudentsHandler = async (dayA) => {
    // dispatch states
    dispatchComponentStates({ type: 'PENDING' });
    const responseData = await getAppointedStudentsRequest(dayA);
    if (responseData.status === 'success') {
      // set states
      setNumberOfStudentsScheduledM(responseData.data.students9);
      setNumberOfStudentsScheduledE(responseData.data.students12);

      // CLEAR
      dispatchComponentStates({ type: 'CLEAR' });
    } else {
      // dispatch states
      dispatchComponentStates({
        type: 'ERROR',
        errorMessage: responseData.message,
      });
    }
  };

  /******************************************************************/
  /* handleCloseSnackbar */
  /******************************************************************/
  const handleCloseSnackbar = () => {
    dispatchComponentStates({ type: 'CLEAR' });
  };
  /******************************************************************/
  /* schedule students */
  /******************************************************************/
  const scheduleStudentsHandler = async () => {
    // get data
    const noOfStudents = noOfStudentsRef.current.value;
    // validation
    if (noOfStudents.trim() === '') {
      // dispatch states
      dispatchComponentStates({
        type: 'ERROR',
        errorMessage: 'يجب ادخال عدد الطلاب',
      });
      return;
    }
    // dispatch states
    dispatchComponentStates({ type: 'PENDING' });
    const data = {
      date: day,
      period: periodSelected,
      NumOfStudents: noOfStudents,
    };
    const responseData = await scheduleStudentsRequest(data);
    if (responseData.status === 'success') {
      // dispatch states
      await getStudentsNumberHandler();
      await getAppointedStudentsHandler(day);
      dispatchComponentStates({
        type: 'SUCCESS',
        successMessage: responseData.message,
      });
    } else {
      // dispatch states
      dispatchComponentStates({
        type: 'ERROR',
        errorMessage: responseData.message,
      });
    }
  };
  /******************************************************************/
  /* printSchedualing */
  /******************************************************************/
  const printSchedualingHandler = async () => {
    if (numberOfStudentsScheduledE === 0 && numberOfStudentsScheduledM === 0) {
      dispatchComponentStates({
        type: 'ERROR',
        errorMessage: 'لا يوجد طلاب مجدولين في هذا اليوم',
      });
      return;
    }
    if (periodPrintedSelected === '9:00' && numberOfStudentsScheduledM === 0) {
      dispatchComponentStates({
        type: 'ERROR',
        errorMessage: 'لا يوجد طلاب مجدولين في الفترة الصباحية في هذا اليوم',
      });
      return;
    }
    if (periodPrintedSelected === '12:00' && numberOfStudentsScheduledE === 0) {
      dispatchComponentStates({
        type: 'ERROR',
        errorMessage: 'لا يوجد طلاب مجدولين في الفترة المسائية في هذا اليوم',
      });
      return;
    }
    setPrintPath(
      `http://eservices.helwan.edu.eg:9000/api/v1/users/exportsAppointedStudents/${day}/${periodPrintedSelected}/${token}`
    );
  };
  /******************************************************************/
  /* downloadStudentData */
  /******************************************************************/
  const downloadStudentData = async () => {
    // dispatch pending
    dispatchComponentStates({ type: 'PENDING' });
    const response = await downloadStudentDataRequest();
    if (response.status === 'success') {
      dispatchComponentStates({
        type: 'CLEAR',
      });
      window.location.href = `${api_url}/${response.data}`;
    } else {
      dispatchComponentStates({
        type: 'ERROR',
        errorMessage: response.message,
      });
    }
  };
  return (
    <Fragment>
      <NavHeader title={'جدولة الاختبارات الشخصية'} mode={'title'} />
      <div className={styles['schedule-container']}>
        <div className={styles['schedule-container__body']}>
          <div className={styles['infos']}>
            {false && (
              <>
                <div className={styles['info']}>
                  <h3>عدد كل الطلبة</h3>
                  <p>{numberOfStudents}</p>
                </div>
                <div className={styles['info']}>
                  <h3>عدد الطلبة اكملوا بيانتهم</h3>
                  <p>{numberOfStudentsCompleted}</p>
                </div>
                <div className={styles['nav-table']}>
                  تنزيل صور ملفات الطلاب الذين اكملوا بياناتهم
                  {!componentStates.pending && (
                    <BtnSmall title={'تنزيل'} onClick={downloadStudentData} />
                  )}
                  {componentStates.pending && (
                    <BtnSmall
                      title={
                        <CircularProgress
                          size={20}
                          sx={{
                            color: '#a18a00',
                          }}
                        />
                      }
                      onClick={downloadStudentData}
                    />
                  )}
                </div>
              </>
            )}
            <br />
            <Seperator word={'جدولة الطلاب'} />
            <div className={styles['info']}>
              <h3>عدد الطلبة في قائمة الانتظار</h3>
              <p>{numberOfStudentsCompletedWaiting}</p>
            </div>
          </div>
        </div>

        <div className={styles['schedule-container__part']}>
          {/* day choose */}
          <div
            className={styles['info-item']}
            style={{
              fontSize: '100%', // Use camelCased property names
            }}
          >
            <h3>اختيار اليوم</h3>
            <DatePicker
              popperClassName={styles['date-picker']}
              size='lg'
              style={{ fontSize: '30px' }}
              dateFormat={datePlaceholder}
              selected={day}
              onChange={async (date) => {
                // convert date to string dd/MM/yyyy
                setDay(date);
                // get appointed students
                await getAppointedStudentsHandler(date);
              }}
            />
          </div>
        </div>
        <div className={styles['nav-table']}>
          عدد الطلاب المجدولين في هذا اليوم
        </div>
        <div className={styles['infos']}>
          <div className={styles['info']}>
            <h3>الفترة الصباحية </h3>
            <p>{numberOfStudentsScheduledM}</p>
          </div>
          <div className={styles['info']}>
            <h3>الفترة المسائية</h3>
            <p>{numberOfStudentsScheduledE}</p>
          </div>
        </div>
        <div className={styles['action-table']}>
          <div className={styles['nav-table']}>جدولة الطلاب في هذا اليوم</div>
          <div className={styles['actions-container']}>
            <div className={styles['form-control']}>
              <select
                id='period'
                name='period'
                value={periodSelected}
                onChange={(e) => {
                  setPeriodSelected(e.target.value);
                }}
              >
                {periodData.map((el) => (
                  <option value={el.value} key={el.value}>
                    {el.title}
                  </option>
                ))}
              </select>
            </div>
            <div className={styles['form-control']}>
              <input
                type='number'
                placeholder='عدد الطلاب'
                ref={noOfStudentsRef}
              />
            </div>
            <BtnSmall title={'جدولة'} onClick={scheduleStudentsHandler} />
          </div>
        </div>
        <div className={styles['action-table']}>
          <div className={styles['nav-table']}>
            طباعة الطلاب المجدولين في هذا اليوم
          </div>
          <div className={styles['actions-container']}>
            <div className={styles['form-control']}>
              <select
                id='period'
                name='period'
                value={periodPrintedSelected}
                onChange={(e) => {
                  setPeriodPrintedSelected(e.target.value);
                }}
              >
                {periodData.map((el) => (
                  <option value={el.value} key={el.value}>
                    {el.title}
                  </option>
                ))}
              </select>
            </div>
            <BtnSmall title={'طباعة'} onClick={printSchedualingHandler} />
          </div>
        </div>
        <span>{printPath}</span>
      </div>
      {/* ********** SUCCESS SNACKBAR ********** */}
      <Snackbar
        open={componentStates.success}
        onClose={handleCloseSnackbar}
        autoHideDuration={2000}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
      >
        <Alert
          severity='success'
          onClose={handleCloseSnackbar}
          dir='ltr'
          sx={{
            width: '100%',
            backgroundColor: '#43A047',
            color: '#fff',
            fontSize: '1.4rem',
            '& .MuiAlert-icon': {
              color: '#fff',
            },
          }}
        >
          !{componentStates.successMessage}
        </Alert>
      </Snackbar>
      {/* ********** ERROR SNACKBAR ********** */}
      <Snackbar
        open={componentStates.error}
        onClose={handleCloseSnackbar}
        autoHideDuration={20000}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
      >
        <Alert
          severity='error'
          onClose={handleCloseSnackbar}
          dir='ltr'
          sx={{
            width: '100%',
            backgroundColor: '#D32F2F',
            color: '#fff',
            fontSize: '1.4rem',
            '& .MuiAlert-icon': {
              color: '#fff',
            },
          }}
        >
          !{componentStates.errorMessage}
        </Alert>
      </Snackbar>
    </Fragment>
  );
});

export { SchedulePage };
